import { Injectable } from '@angular/core';

@Injectable()
export class FunctionService {

  constructor() { }

  /**
   * Converte objeto para urlencode
   * @param data
   */
  public formatData(data) {
    
    return Object.keys(data).map(function(key){
      return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
    }).join('&');
  }

}



// WEBPACK FOOTER //
// /var/www/minha-at3-cliente/src/app/provider/function.service.ts